import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import { defineComponent as _defineComponent } from 'vue';
import { useVentureId } from '~/functions/accounts';
import { renderSafeMarkdown } from '~/functions/markdown';
import { reportingDefaultPeriods } from '~/functions/reporting';
import { Module, ReportingRequestType, ReportingVentureStatus, useGetAccountQuery, useGetReportingRequestQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: '_requestId',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var ventureId = useVentureId();
    var requestId = computed(function () {
      return String(route.params.requestId || '');
    });
    var _useGetAccountQuery = useGetAccountQuery(computed(function () {
        return {
          id: ventureId.value
        };
      })),
      accountResult = _useGetAccountQuery.result;
    var hasMetricsModule = computed(function () {
      var _accountResult$value, _accountResult$value$;
      return (((_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : (_accountResult$value$ = _accountResult$value.getAccount) === null || _accountResult$value$ === void 0 ? void 0 : _accountResult$value$.bookedModules) || []).includes(Module.Metrics);
    });
    var hasEsgModule = computed(function () {
      var _accountResult$value2, _accountResult$value3;
      return (((_accountResult$value2 = accountResult.value) === null || _accountResult$value2 === void 0 ? void 0 : (_accountResult$value3 = _accountResult$value2.getAccount) === null || _accountResult$value3 === void 0 ? void 0 : _accountResult$value3.bookedModules) || []).includes(Module.Esg);
    });
    var _useGetReportingReque = useGetReportingRequestQuery(computed(function () {
        return {
          id: requestId.value
        };
      }), computed(function () {
        return {
          enabled: (hasMetricsModule.value || hasEsgModule.value) && !!requestId.value,
          // network-only, not cache-and-network: the ESG branch below makes an
          // irreversible navigation decision off this venture's status. A cache
          // hit from an earlier (e.g. still-in-progress) visit would fire that
          // redirect on stale data before the fresh network response arrives -
          // and once we've navigated away, this component is gone and can't
          // correct itself.
          fetchPolicy: 'network-only'
        };
      })),
      result = _useGetReportingReque.result;
    var request = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getReportingRequest;
    });
    var showCategorySidebar = computed(function () {
      var _request$value;
      return ((_request$value = request.value) === null || _request$value === void 0 ? void 0 : _request$value.requestType) === ReportingRequestType.Kpi;
    });
    var ventureRow = computed(function () {
      var _request$value2;
      return (((_request$value2 = request.value) === null || _request$value2 === void 0 ? void 0 : _request$value2.ventures) || []).find(function (row) {
        return String(row.ventureId) === String(ventureId.value);
      });
    });
    var ventureStatus = computed(function () {
      var _ventureRow$value;
      return ((_ventureRow$value = ventureRow.value) === null || _ventureRow$value === void 0 ? void 0 : _ventureRow$value.status) || 'NOT_STARTED';
    });
    watchEffect(function () {
      var _request$value3, _ventureRow$value2, _ventureRow$value3;
      if (((_request$value3 = request.value) === null || _request$value3 === void 0 ? void 0 : _request$value3.requestType) !== ReportingRequestType.Esg) return;
      var questionnaireId = (_ventureRow$value2 = ventureRow.value) === null || _ventureRow$value2 === void 0 ? void 0 : _ventureRow$value2.questionnaireId;
      var isLocked = ((_ventureRow$value3 = ventureRow.value) === null || _ventureRow$value3 === void 0 ? void 0 : _ventureRow$value3.status) === ReportingVentureStatus.Complete;
      if (questionnaireId && !isLocked) {
        router.replace("/".concat(ventureId.value, "/esg/edit/").concat(questionnaireId));
        return;
      }
      router.replace({
        path: "/".concat(ventureId.value, "/esg"),
        // Land on the period this request was for, not whichever version is
        // otherwise most recent - a company can have newer ESG versions than
        // the one a given request covers.
        query: questionnaireId ? {
          questionnaireId: String(questionnaireId)
        } : {}
      });
    });
    var ventureMetricIds = computed(function () {
      var _ventureRow$value4;
      return ((_ventureRow$value4 = ventureRow.value) === null || _ventureRow$value4 === void 0 ? void 0 : _ventureRow$value4.metricIds) || [];
    });
    var ventureStatusSummary = computed(function () {
      var _ventureRow$value5;
      var summary = (_ventureRow$value5 = ventureRow.value) === null || _ventureRow$value5 === void 0 ? void 0 : _ventureRow$value5.statusSummary;
      if (summary) return summary;
      var fallbackTotal = ventureMetricIds.value.length;
      return {
        totalKpis: fallbackTotal,
        completedKpis: 0,
        skippedKpis: 0,
        incompleteKpis: fallbackTotal
      };
    });
    var renderedDescription = computed(function () {
      var _request$value4;
      return (_request$value4 = request.value) !== null && _request$value4 !== void 0 && _request$value4.description ? renderSafeMarkdown(request.value.description) : '';
    });
    var defaultPeriods = computed(function () {
      var _request$value5;
      return (_request$value5 = request.value) !== null && _request$value5 !== void 0 && _request$value5.referencePeriod ? reportingDefaultPeriods(request.value.referencePeriod) : [];
    });
    var referencePeriodsToEmphasize = computed(function () {
      var _request$value6;
      return (_request$value6 = request.value) !== null && _request$value6 !== void 0 && _request$value6.referencePeriod ? [request.value.referencePeriod] : [];
    });
    var assignmentFilters = computed(function () {
      return {
        assigneeIds: [ventureId.value],
        metricIds: ventureMetricIds.value
      };
    });
    var formatDueDate = function formatDueDate(value) {
      if (!value) return '';
      return new Date(value).toLocaleDateString();
    };
    watchEffect(function () {
      if (!request.value || request.value.requestType === ReportingRequestType.Esg) {
        return;
      }
      if (ventureRow.value) return;
      router.replace("/".concat(ventureId.value, "/modules"));
    });
    return {
      __sfc: true,
      route: route,
      router: router,
      ventureId: ventureId,
      requestId: requestId,
      accountResult: accountResult,
      hasMetricsModule: hasMetricsModule,
      hasEsgModule: hasEsgModule,
      result: result,
      request: request,
      showCategorySidebar: showCategorySidebar,
      ventureRow: ventureRow,
      ventureStatus: ventureStatus,
      ventureMetricIds: ventureMetricIds,
      ventureStatusSummary: ventureStatusSummary,
      renderedDescription: renderedDescription,
      defaultPeriods: defaultPeriods,
      referencePeriodsToEmphasize: referencePeriodsToEmphasize,
      assignmentFilters: assignmentFilters,
      formatDueDate: formatDueDate,
      ReportingRequestType: ReportingRequestType
    };
  }
});